App.components.ws_btn = {
	define: function() {
		customElements.define("ws-btn", class extends HTMLElement {
			constructor() {
				super();
			}
			render() {
				let clsArr = [];
				let btnDouble = false;
				let bg = this.getAttribute('bg') || '';
				let id = this.getAttribute('button-id') || '';
				let rel = this.getAttribute('rel') || '';
				let cls = this.getAttribute('name') || '';
				let text = this.getAttribute('text') || '';
				let onclick = this.getAttribute('button-onclick') || '';
				let disabled = this.getAttribute('disabled');
				let leftIcon = this.getAttribute('left-icon') || '';
				let rightIcon = this.getAttribute('right-icon') || '';
				let leftIconSprite = this.getAttribute('left-icon-data-sprite') || '';
				let rightIconSprite = this.getAttribute('right-icon-data-sprite') || '';
				let modalUrl = this.getAttribute('data-modal-url') || '';
				let modalTitle = this.getAttribute('data-modal-title') || '';
				let modalWidth = this.getAttribute('data-modal-width') || '';
				let modalBackup = this.getAttribute('data-modal-backup') || '';
				let modalLevel = this.getAttribute('data-modal-level') || '';
				let modalGroup = this.getAttribute('data-modal-group') || '';
				let analyticsTitle = this.getAttribute('button-data-analytics-title') || '';
				let children = this.getAttribute('children') || '';
				let childElems = this.querySelectorAll('*');
				let imgElem = this.firstElementChild;
				let tmp = cls.split(' ');
				if (!cls) return false;

				this.innerHTML = '';
				tmp.forEach(function(val) {
					if (val !== 'btn-double') {
						clsArr.push(val);
					} else {
						btnDouble = val;
					}
				});
				cls = clsArr.join(' ');
				if (bg) cls += ' ' + 'btn-bg';

				if (cls && cls.match(/btn-sum/)) {
					leftIcon = 'sum';
				} else if (cls && cls.match(/btn-timer/)) {
					leftIcon = 'stopwatch';
				} else if (cls && cls.match(/btn-time/)) {
					leftIcon = 'timer-play';
					rightIcon = 'chevron-right';
					rightIconSprite = 'arrows';
				}
				if (cls && cls.match(/btn-money/)) {
					leftIcon = 'hour_hand';
					rightIcon = 'chevron-right';
					rightIconSprite = 'arrows';
				}
				if (cls && (text || leftIcon || rightIcon)) {
					if (!btnDouble) {
						let buttonElem = document.createElement('button');
						buttonElem.setAttribute('type', 'button');
						buttonElem.setAttribute('class', cls);
						if (id) buttonElem.setAttribute('id', id);
						if (rel) buttonElem.setAttribute('rel', rel);
						if (modalUrl) buttonElem.setAttribute('data-modal-url', modalUrl);
						if (modalTitle) buttonElem.setAttribute('data-modal-title', modalTitle);
						if (modalWidth) buttonElem.setAttribute('data-modal-width', modalWidth);
						if (modalBackup) buttonElem.setAttribute('data-modal-backup', modalBackup);
						if (modalLevel) buttonElem.setAttribute('data-modal-level', modalLevel);
						if (modalGroup) buttonElem.setAttribute('data-modal-group', modalGroup);
						if (analyticsTitle) buttonElem.setAttribute('data-analytics-title', analyticsTitle);
						if (disabled === null && onclick) buttonElem.setAttribute('onclick', onclick);
						if (disabled !== null) buttonElem.disabled = true;

						if (leftIcon && leftIcon != 'img') {
							buttonElem.innerHTML += '<ws-icon class="btn-left-icon" name="'+leftIcon+'"'+(leftIconSprite ? ' data-sprite="'+leftIconSprite+'"' : '')+'></ws-icon>';
						}
						if (leftIcon == 'img') {
							buttonElem.appendChild(imgElem);
						}
						if (text) {
							let textElem = document.createElement('span');
							textElem.innerHTML = text;
							buttonElem.appendChild(textElem);
						}
						if (rightIcon) {
							buttonElem.innerHTML += '<ws-icon class="btn-right-icon" name="'+rightIcon+'"'+(rightIconSprite ? ' data-sprite="'+rightIconSprite+'"' : '')+'></ws-icon>';
						}
						if (children) {
							childElems.forEach(childElem => {
								buttonElem.appendChild(childElem);
							})
						}
						this.appendChild(buttonElem);
					} else if ((text || leftIcon) && rightIcon) {
						let div = document.createElement('div');
						let button1 = document.createElement('button');
						let button2 = document.createElement('button');
						if (disabled !== null) {
							let onclick1 = this.getAttribute('left-button-onclick') || '';
							let onclick2 = this.getAttribute('right-button-onclick') || '';
							if (onclick1) button1.setAttribute('onclick', onclick1);
							if (onclick2) button2.setAttribute('onclick', onclick2);
							button1.disabled = true;
							button2.disabled = true;
						}

						div.setAttribute('class', btnDouble);
						button1.setAttribute('class', cls);
						button2.setAttribute('class', cls);
						button1.setAttribute('type', 'button');
						button2.setAttribute('type', 'button');
						button2.innerHTML += '<ws-icon class="btn-right-icon" name="'+rightIcon+'"'+(rightIconSprite ? ' data-sprite="'+rightIconSprite+'"' : '')+'></ws-icon>';
						if (leftIcon) {
							button1.innerHTML += '<ws-icon class="btn-left-icon" name="'+leftIcon+'"'+(leftIconSprite ? ' data-sprite="'+leftIconSprite+'"' : '')+'></ws-icon>';
						}
						if (text) {
							let textElem = document.createElement('span');
							textElem.innerHTML = text;
							button1.appendChild(textElem);
						}
						div.appendChild(button1);
						div.appendChild(button2);
						this.appendChild(div);
					}
				}
			}
			static get observedAttributes() {
				return ["name", "text", "left-icon", "right-icon", "disabled", "left-icon-data-sprite", "right-icon-data-sprite"];
			}
			connectedCallback() {
				if (!this.rendered) {
					this.render();
					this.rendered = true;
					this.connected = true;
				}
			}
			attributeChangedCallback() {
				if (this.connected) {
					this.render();
				}
			}
		});
	}
}